/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const LampCeiling = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 2v5" }],
    ["path", { d: "M6 7h12l4 9H2l4-9Z" }],
    ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0" }]
  ]
];

export { LampCeiling as default };
//# sourceMappingURL=lamp-ceiling.js.map
